<template>
  <div>
    <div class="content index-content" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
         infinite-scroll-distance="10">
      <div v-if="items.length" class="content fd-content" style="padding-top: 0;">
        <span class="fd-search-result">共{{itemTotal}}个活动</span>

        <div class="show-box">
          <ul class="show-list">
            <li class="show-list-li" v-if="items" v-for="(item,ind) in items" :key="ind">
              <a href="javascript:void(0);" @click="route(item.id)">
                <!--  <router-link tag="a" :to="{name:'Detail',params:{id:item.id} }">-->
                <div class="show-remd-logo">
                  <img v-if="item.hostunit" :src="item.hostunit.host_avatar" alt=""/>
                </div>
                <div class="show-remd-tit" v-if="item.hostunit">
                  {{item.hostunit.channel_name}}
                </div>
                <div class="show-remd-bg">
                  <div class="pic-box">
                    <img v-if="item.playbill" v-lazy="item.playbill.playbill_small_h5 +'?p=3&o=2&w=350&h=197'">
                  </div>
                  <p>{{item.title}}</p>
                </div>

                <!--</router-link>-->
              </a>
            </li>
          </ul>

          <!-- load -->
          <div>
            <div class="id-content-inner">
              <div class="loader" v-show="!busy">
                <div class="loader-inner ball-pulse" style="display: block">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="content fd-content" style="padding-top: 0;padding-bottom: 44px">
        <div class="fd-search-none">
          <div class="content index-content">
            <div class="id-content-inner">
              <div class="loader">
                <div class="loader-inner ball-pulse" style="display: block">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        channelId: 0,
        channelPic: '',
        items: [],
        itemTotal: 0,
        busy: false,
        pageNum: 0,
        pageSize: 10,
        num: true,
        globalUrl: API.GlobalUrl
      }
    },
    created: function () {

      this.channelId = this.$route.params.id;
      $('.id-nav-recom').eq(this.channelId).addClass('nav-on').siblings().removeClass('nav-on');

      this.$watch(function () {
        this.items = []
      })
    },
    watch: {
      '$route': function () {
        this.channelId = this.$route.params.id;
        this.pageNum = 1;
        this.fetchData(false)
      }
    },
    methods: {
      route(id) {
        var url = '';
        var hrefHTML = this.hrefHTML(0, id)
        if (hrefHTML) {
          window.location.href = hrefHTML
        } else {
          window.location.href = API.UrlName + 'detail/' + id
        }
      },
      fetchData(flag) {
        let param = {
          'channel_id': this.channelId,
          'page': this.pageNum,
          'pagesize': this.pageSize,
          version: 2
        };
        this.$http.get(API.GetActivities, {params: param}).then(res => {
          if (res.code === 0) {
            this.itemTotal = res.total;
            if (flag) {
              // 多次加载数据
              this.items = this.items.concat(res.data);
              if (res.data.length === 0 || this.items.length === res.total) {
                this.busy = true
              } else {
                this.busy = false
              }
            } else {
              // 第一次加载数据
              this.items = res.data;
            }
            if (res.data.length === 0 || this.items.length === res.total) {
              this.busy = true
            } else {
              this.busy = false
            }
            if (res.total == 0) {
              setTimeout(function () {
                $('.fd-search-none').html('没有找到您感兴趣的活动，再试一次！')
              }, 200)
            }
            if (this.num) {
              this.num = false;
            }

            this.$nextTick(function () {
              this.PictureRatio()
            }, 500)
          }
        })
      },
      loadMore: function () {
        if (this.busy == false) {
          setTimeout(() => {
            this.pageNum++
            this.fetchData(true)
          }, 500)
        }

      }
    }
  }
</script>

<style>
  .fd-content .fd-search-result {
    padding: 17px 18px 15px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/active.vue